/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimReservationWithTimeslot } from './ClaimReservationWithTimeslot';
import {
    ClaimReservationWithTimeslotFromJSON,
    ClaimReservationWithTimeslotFromJSONTyped,
    ClaimReservationWithTimeslotToJSON,
} from './ClaimReservationWithTimeslot';

/**
 * 
 * @export
 * @interface ClaimReservations
 */
export interface ClaimReservations {
    /**
     * 
     * @type {Array<ClaimReservationWithTimeslot>}
     * @memberof ClaimReservations
     */
    reservations: Array<ClaimReservationWithTimeslot>;
}

/**
 * Check if a given object implements the ClaimReservations interface.
 */
export function instanceOfClaimReservations(value: object): value is ClaimReservations {
    if (!('reservations' in value) || value['reservations'] === undefined) return false;
    return true;
}

export function ClaimReservationsFromJSON(json: any): ClaimReservations {
    return ClaimReservationsFromJSONTyped(json, false);
}

export function ClaimReservationsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimReservations {
    if (json == null) {
        return json;
    }
    return {
        
        'reservations': ((json['reservations'] as Array<any>).map(ClaimReservationWithTimeslotFromJSON)),
    };
}

export function ClaimReservationsToJSON(value?: ClaimReservations | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'reservations': ((value['reservations'] as Array<any>).map(ClaimReservationWithTimeslotToJSON)),
    };
}

